<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Arrive Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="fromDate"/> ~ <CustomDatePicker v-model="toDate"/></span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="vendorCode" ph="Vendor Code" :showName="false" :vendorOnly="true" @set-partner="setPartner" />
				</span>

				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5"> <ItemClassSelect v-model="classCode" :showName="false" /> </span>

				<em class="lt_text">Carton</em>
				<span class="int_type_no_border mgr_5"> <input type="number" v-model="carton" class="tbl_int ssm_int" /> </span>

				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="fixed-table-container">
			<div class="mgb_20" style="margin: 0 auto;">
				<div class="al_center" style="margin: 0 auto;">
					<label class="mgr_5">
						<em class="lt_text">Carton</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.carton | commaSeparated" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Qty</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.qty | commaSeparated" />
					</label>
					<label class="mgr_5">
						<em class="lt_text">Amount</em>
						<input type="text" autocomplete="off" class="tbl_int ssm3_int al_right" disabled="disabled" v-bind:value="root.value.amount | toCurrency" />
					</label>
				</div>
			</div>
			<div class="table-wrapper" style="height: 90%">
				<table class="list_tbl sticky_list_tbl" v-columns-resizable id="output">
					<colgroup>
						<col style="width: 5%" />
						<col style="width: 5%" />
						<col style="width: 15%" />
						<col style="width: 5%" />
						<col style="width: 5%" />
						<col style="width: 5%" />
						<col />
						<col style="width: 10%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
						<col style="width: 7%" />
					</colgroup>
					<thead>
						<tr>
							<th>Arrive Date</th>
							<th>Vendor</th>
							<th>Vendor</th>
							<th>BL No</th>
							<th>Carton</th>
							<th>{{ headers.class }}</th>
							<th>{{ headers.class }} Description</th>
							<th>Color</th>
							<th>Qty</th>
							<th>Price</th>
							<th>amount</th>
							<th>Inv Qty</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="root !== ''">
							<template v-for="date in root.value.list">
								<template v-for="(vendor, vendorIndex) in date.list">
									<template v-for="(cls, clsIndex) in vendor.list">
										<template v-for="(item, itemIndex) in cls.list">
											<tr :key="item.itemNo">
												<td>{{ (vendorIndex === 0 && clsIndex === 0 && itemIndex === 0 ? date.date : '') | moment('MM-DD-yyyy') }}</td>
												<td>{{ clsIndex === 0 && itemIndex === 0 ? vendor.vendorCode : '' }}</td>
												<td>{{ clsIndex === 0 && itemIndex === 0 ? vendor.vendorName : '' }}</td>
												<td>
													<a href="javascript:void(0)" @click="shipmentGo(vendor.shNo)" v-if="clsIndex === 0 && itemIndex === 0">{{ vendor.sh_dn }}</a>
												</td>
												<td class="al_right">{{ clsIndex === 0 && itemIndex === 0 ? vendor.carton : '' }}</td>
												<td>{{ itemIndex === 0 ? cls.classCode : '' }}</td>
												<td>{{ itemIndex === 0 ? cls.className : '' }}</td>
												<td>{{ item.colorCode }}</td>
												<td class="al_right">{{ item.qty | commaSeparated }}</td>
												<td class="al_right">{{ item.price | toCurrency }}</td>
												<td class="al_right">{{ item.amount | toCurrency }}</td>
												<td class="al_right">{{ item.onHand | commaSeparated }}</td>
											</tr>
										</template>
									</template>
								</template>
							</template>
							<tr>
								<td colspan="4" class="al_right">TOTAL</td>

								<td class="al_right">{{ root.value.carton | commaSeparated }}</td>
								<td></td>
								<td></td>
								<td></td>
								<td class="al_right">{{ root.value.qty | commaSeparated }}</td>
								<td></td>
								<td class="al_right">{{ root.value.amount | toCurrency }}</td>
								<td></td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="Excel">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { daysAdd, daysAgo, today } from '@/utils/date';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import { objectToFormData, shipmentPageGo } from '@/api/util';
import { apiPreReceiving } from '@/api/purchase/purchase';
import XLSX from 'xlsx-js-style';

export default {
	props: ['headers'],
	data: function() {
		return {
			fromDate: today(),
			toDate: daysAdd(7),
			vendorCode: null,
			classCode: null,
			carton: null,
			root: {
				value: {
					carton: '',
					amount: '',
					qty: '',
				},
			},
			itemClassList: [],
		};
	},
	computed: {},
	components: {
		CustomDatePicker,
		PartnerSelect,
		ItemClassSelect,
	},
	methods: {
		setPartner(partner) {
			this.vendor_code = partner.code;
			this.search();
		},
		reset() {
			this.fromDate = daysAgo(6);
			this.toDate = today();
			this.vendorCode = null;
			this.classCode = null;
			this.carton = null;
		},
		async search() {
			const paramObj = {
				fromDate: this.fromDate,
				toDate: this.toDate,
				vendorCode: this.vendorCode,
				classCode: this.classCode,
				carton: this.carton,
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiPreReceiving(param);

			this.root = data;
		},

		Excel() {
			this.$nextTick(function() {
				const elt = document.getElementById('output');
				const wb = XLSX.utils.table_to_book(elt, { raw: true });
				return XLSX.writeFile(wb, 'Pre_Receiving_' + this.fromDate + '_' + this.toDate + '.xlsx');
			});
		},
		shipmentGo(sh_no) {
			shipmentPageGo(sh_no);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_PreReceiving');
		this.$store.commit('setSubTitle', 'Purchase -> Pre Receiving List');
	},
};
</script>

<style></style>
